import React from 'react'
import { DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import ScreenshotUpload from 'scenes/Job/components/JobApplicationDialog/components/ScreenshotUpload'
import ResponsiveDialog from 'components/ResponsiveDialog'
import TextField from 'components/TextField'
import TextArea from 'components/TextArea'
import Button from 'components/Button'
import FormSubmitButton from 'components/FormSubmitButton'
import { graphql, useFragment } from 'react-relay'
import { useCodeTestBrowserForm } from 'components/CodeTestBrowser/useCodeTestBrowserForm'
import { CodeSubmissionDialog_Project$key } from '__generated__/CodeSubmissionDialog_Project.graphql'
import { FormProvider } from 'react-hook-form'

function CodeSubmissionDialog({ projectFragmentRef, onClose }: { projectFragmentRef: CodeSubmissionDialog_Project$key, onClose: () => void }) {
  const theme = useTheme()
  const project = useFragment(graphql`
    fragment CodeSubmissionDialog_Project on Project {
      id
      title
      submission {
        description
        url
      }
      ...useCodeTestBrowserForm_Project
    }
  `, projectFragmentRef)

  const form = useCodeTestBrowserForm(onClose, project)
  const { useFormField, submit } = form
  return (
    <ResponsiveDialog open onClose={onClose}>
      <DialogTitle>
        Submit a project
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {project?.title}
        </DialogContentText>

        <FormProvider {...form}>
          <form onSubmit={submit}>
            <div style={{ marginBottom: theme.spacing(2) }}>
              <TextField
                {...useFormField('title', 'typing')}
                name="title"
                placeholder="Project Title"
              />
            </div>

            <div style={{ marginBottom: theme.spacing(2) }}>
              <TextField
                {...useFormField('url', 'typing')}
                name="url"
                fullWidth
                placeholder="Project repository URL (e.g. Github)"
              />
            </div>

            <div style={{ margin: theme.spacing(2, 0) }}>
              <ScreenshotUpload
                {...useFormField('screenshotUrl', 'selection')}
                name="screenshotUrl"
              />
            </div>

            <div style={{ paddingTop: theme.spacing(1) }}>
              <TextArea
                {...useFormField('description', 'typing')}
                name="description"
                style={{ minHeight: 120 }}
                label="Additional notes"
                placeholder="Additional information about the project... (optional)"
              />
            </div>

            <FormSubmitButton
              onClick={submit}
              dataCy="submit-code-test"
              label="Submit"
            />
          </form>
        </FormProvider>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} data-cy="cancel">
          Cancel
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}

export default React.memo(CodeSubmissionDialog)
